import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type sessionDataType = {
  api: { apiKey: string; apiUrl: string };
  darkmode: boolean;
  [key: string]: any;
};

const getInitialState = (): sessionDataType => {
  const raw = sessionStorage.getItem("darkmode");
  const selectedOption =
    raw === null || raw === undefined ? true : raw === "true";

  return {
    currentPage: window.location.pathname,
    search: {
      term: "",
      type: "",
      page: 1,
      totalPages: 1,
      totalResults: 0,
    },
    api: {
      apiKey: "db1a3d4fc9949395b6300a619305310d",
      apiUrl: "https://api.themoviedb.org/3/",
    },
    darkmode: selectedOption,
  };
};

const initialState: sessionDataType = getInitialState();
export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    toggleDarkMode: (state, action: PayloadAction<[]>) => {
      //console.log("action:", action);
      // console.log("state:", current(state));
      return { ...state, darkmode: !state.darkmode };
    },
  },
});
export const { toggleDarkMode } = sessionSlice.actions;
export default sessionSlice.reducer;
